import auth from './modules/auth/auth'
import users from './modules/admin/users'
import boards from './modules/params/boards'
import groups from './modules/params/groups'
import formComponents from './modules/params/formComponents'
import surveys from './modules/params/surveys'
import surveysForms from './modules/params/surveysForms'
import distributionSetups from './modules/params/distributionSetups'
import tickets from './modules/registers/tickets'
import contacts from './modules/registers/contacts'
import distributions from './modules/distributions/distributions'
import distributionUsers from './modules/distributions/distributionUsers'
import surveysUser from './modules/surveyUser/surveyUser'
import reports from './modules/reports/reports'

export default {
  auth,
  users,
  boards,
  groups,
  formComponents,
  surveys,
  surveysForms,
  distributionSetups,
  tickets,
  contacts,
  distributions,
  distributionUsers,
  surveysUser,
  reports,
}
